export default [
    //FOR BRANCH USER==========================================================================
    {
        key: "newPr",
        status: "New PR",
        label: "This PR is not Subbmited Yet",
        reject_reason: "",
        actionButtons: [
            {
                endPoint: "updatePrStatus",
                payLoad: {
                    id: "", //record Id To Update
                    newStatus: "Submitted HOD",
                },

                getReason: false,//if True, a popup will show to ask user to type the reason
                rejectDialogTitle: "",
                rejectReasonMessage: "Why Are you Rejecting this PR?",

                buttonLabel: "Submit To HOD",
                color: 'success',
                icon: "icon-send",
                btnSize: "large",

                confirmationTitle: "Submission",
                confirmationMessage: "Are you sure you want to submit this to your HOD?",
                successMessage: "This PR has been successfully Submitted to HOD",

                sucessEventName: "changeView",
                successEventValue: "list",
            },

        ]

    },
    {
        key: "userApprovedPR",
        status: "Submitted PR Team",
        label: "This PR has been Approved by your HOD",
        reject_reason: "",
        actionButtons: [

        ]

    },
    {
        key: "Submitted HOD",
        status: "Submitted HOD",
        label: "This PR is waiting for Approval by your HOD",
        reject_reason: "",
        actionButtons: [

        ]
    },
    {
        key: "userApprovedByProcurement",
        status: "PO Generated",
        label: "This PR has been approved By Procurement Team",
        reject_reason: "",
        actionButtons: [

        ]
    },
    {
        key: "Rejected PR",
        status: "Rejected PR",
        label: "This PR was rejected by your HOD",
        reject_reason: "",
        actionButtons: [

        ]
    },
   

    //----------------------------------------------------------------------------------------------
    //FOR HOD==========================================================================

    {
        key: "HOD Pending Approval",
        status: "Submitted HOD",
        label: "Evaluate this PR and Approve or Reject it.",
        reject_reason: "",
        actionButtons: [
            {
                endPoint: "updatePrStatus",
                payLoad: {
                    id: "", //record Id To Update
                    newStatus: "Submitted PR Team",
                },

                getReason: false,//if True, a popup will show to ask user to type the reason
                rejectDialogTitle: "",
                rejectReasonMessage: "",

                buttonLabel: "Approve & Submit To Procurement",
                color: 'success',
                icon: "icon-thumbs-up",
                btnSize: "large",

                confirmationTitle: "Submission",
                confirmationMessage: "Are you sure you want to Approved this PR?",
                successMessage: "This PR has been successfully Approved and submitted to Procurement Team",

                sucessEventName: "changeView",
                successEventValue: "list",
            },
            {
                endPoint: "updatePrStatus",
                payLoad: {
                    id: "", //record Id To Update
                    newStatus: "Rejected by HOD",
                },

                getReason: true,//if True, a popup will show to ask user to type the reason
                rejectDialogTitle: "Reject Confirmation",
                rejectReasonMessage: "Why Are you Rejecting this PR?",

                buttonLabel: "Reject this PR",
                color: 'danger',
                icon: "icon-thumbs-down",
                btnSize: "large",

                confirmationTitle: "Rejection",
                confirmationMessage: "",
                successMessage: "This PR has been successfully Rejected",

                sucessEventName: "changeView",
                successEventValue: "list",
            }
        ]
    },
    {
        key: "submittedToPr",
        status: "Submitted PR Team",
        label: "This PR Has been approved and Submitted to Procurement Team",
        reject_reason: "",
        actionButtons: [

        ]
    },
    {
        key: "hodRejectedByhod",
        status: "Rejected by HOD",
        label: "You Rejected this PR",
        reject_reason: "",
        actionButtons: [

        ]
    },
    {
        key: "hodRejectedByPR",
        status: "Rejected by Procurement",
        label: "This PR Has been rejected by Procurement Team",
        reject_reason: "",
        actionButtons: [

        ]
    },
    //----------------------------------------------------------------------------------------------
   
    //FOR PROCUREMENT TEAM==========================================================================
    {
        key: "pendingApprovalByPR",
        status: "Submitted PR Team",
        label: "Evaluate this PR and Approve or Reject it.",
        reject_reason: "",
        actionButtons: [
            {
                endPoint: "updatePrStatus",
                payLoad: {
                    id: "", //record Id To Update
                    newStatus: "PO Generated",
                },

                getReason: false,//if True, a popup will show to ask user to type the reason
                rejectDialogTitle: "",
                rejectReasonMessage: "",

                buttonLabel: "Approve, Generate PO & Submit To Finance",
                color: 'success',
                icon: "icon-thumbs-up",
                btnSize: "large",

                confirmationTitle: "Submission",
                confirmationMessage: "Are you sure you want to Approved this PR?",
                successMessage: "PO has been successfully Approved and submitted to Finance Manager",

                sucessEventName: "changeView",
                successEventValue: "list",
            },
            {
                endPoint: "updatePrStatus",
                payLoad: {
                    id: "", //record Id To Update
                    newStatus: "Rejected by Procurement",
                },

                getReason: true,//if True, a popup will show to ask user to type the reason
                rejectDialogTitle: "Reject Confirmation",
                rejectReasonMessage: "Why Are you Rejecting this PR?",

                buttonLabel: "Reject this PR",
                color: 'danger',
                icon: "icon-thumbs-down",
                btnSize: "large",

                confirmationTitle: "Rejection",
                confirmationMessage: "",
                successMessage: "This PR has been successfully Rejected",

                sucessEventName: "changeView",
                successEventValue: "list",
            }
        ]
    },
    {
        key: "Rejected by Procurement",
        status: "Rejected by Procurement",
        label: "This PR was rejected by Procurement Team",
        reject_reason: "",
        actionButtons: [

        ]
    },
    {
        key: "PO Generated",
        status: "PO Generated",
        label: "PO has been generated from this PR",
        reject_reason: "",
        actionButtons: [

        ]
    },
]